/* bs-lang-switcher — abre/cierra el selector de idioma colapsado (móvil, topbar).
   El desplegable solo existe visualmente en móvil (CSS); en desktop el toggle está oculto
   y el form se muestra inline, así que este script es inofensivo ahí (el toggle no se pulsa).
   Marca [data-open] en el contenedor .bs-lang; el CSS hace el resto. */
(function () {
  'use strict';

  function close(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    var t = el.querySelector('.bs-lang__toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    var open = document.querySelectorAll('[data-bs-lang][data-open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) close(open[i]);
    }
  }

  function init(scope) {
    var root = scope || document;
    var switchers = root.querySelectorAll('[data-bs-lang]');
    for (var i = 0; i < switchers.length; i++) {
      var el = switchers[i];
      if (el.dataset.bsLangInit) continue;
      el.dataset.bsLangInit = '1';

      var toggle = el.querySelector('.bs-lang__toggle');
      if (!toggle) continue;

      /* Cierre en closure sobre el contenedor de esta instancia. */
      (function (container, btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = container.hasAttribute('data-open');
          closeAll(container);
          if (isOpen) {
            close(container);
          } else {
            container.setAttribute('data-open', '');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      })(el, toggle);
    }
  }

  /* Cerrar al pulsar fuera de cualquier selector abierto. */
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('[data-bs-lang][data-open]');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(e.target)) close(open[i]);
    }
  });

  /* Escape cierra todos. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll(null);
  });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }

  /* Re-init cuando el Customizer recarga la sección del header. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
